import Rails from '@rails/ujs';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/browser';
import * as Components from './rails_ujs/components';
 
if (!window._rails_loaded) {
  Rails.start();
}

Sentry.init({
  dsn: window.SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  replaysSessionSampleRate: 0.1, 
  replaysOnErrorSampleRate: 1.0,
  ignoreErrors: [
    'TypeError: Failed to fetch',
    'Error: Request failed with status code 404',
  ],
});

// Set user and tags for Sentry
Sentry.setUser({ email: window.currentUserEmail });
Sentry.setTags({ service: 'frontend-javascript' });

try {
  window.components = { ...Components };
  window.quantmanLoadComponent = (Component, props, componentId) => {
    const domNode = document.getElementById(componentId);
    const root = createRoot(domNode);
    root.render(<Component {...props} />);
  };
} catch (error) {
  console.error('Error in application', error);
}
